import { invokeApi } from "../utils";

export const loginApi = (postData) =>
  invokeApi({ path: "/login", method: "POST", postData, isAuth: false });

export const logoutApi = () => invokeApi({ path: "/logout", method: "POST" });

export const forgotPasswordApi = (postData) =>
  invokeApi({
    path: "/forgotPassword",
    method: "POST",
    postData,
    isAuth: false,
  });

export const verifyResetTokenApi = (postData) =>
  invokeApi({
    path: "/verifyResetToken",
    method: "POST",
    postData,
    isAuth: false,
  });

export const resetPasswordApi = (postData) =>
  invokeApi({
    path: "/resetPassword",
    method: "POST",
    postData,
    isAuth: false,
  });

export const verifySetPasswordTokenApi = (postData) =>
  invokeApi({
    path: "/verifySetPasswordToken",
    method: "POST",
    postData,
    isAuth: false,
  });

export const setPasswordApi = (postData) =>
  invokeApi({ path: "/setPassword", method: "POST", postData, isAuth: false });

export const getCurrentUserApi = () => invokeApi({ path: "/me" });
